import { DataEnrichmentPreviewRequestDto } from "@advanced-sales-technologies/backend-client/models/DataEnrichmentPreviewRequestDto";
import { useMutation } from "@tanstack/react-query";

import useSalesyApiClient from "@/hooks/useSalesyApiClient";

export const usePreviewMapping = () => {
  const { apiClient } = useSalesyApiClient();

  const mutation = useMutation({
    mutationFn: (requestBody: DataEnrichmentPreviewRequestDto) => apiClient.listsEnrichment.preview({ requestBody }),
  });

  return {
    ...mutation,
    previewMapping: mutation.mutate,
  };
};
